export enum PAYMENT_MEDIUM {
  TRADE_TO_IPO = 'TRADE_TO_IPO',
  EFT = 'EFT',
  CHEQUE = 'CHEQUE',
  CASH = 'CASH',
  PAYMENT_GATEWAY = 'PAYMENT_GATEWAY',
  MOBILE_BANKING = 'MOBILE_BANKING',
}
